import React from "react";
import AgeBySeverityTrend, {
  type AgeBySeverityTrendProps,
} from "../AgeBySeverityTrend/AgeBySeverityTrend";
import { ageBySeverityTrendConfigs } from "../AgeBySeverityTrend/ageBySeverityTrendConfig";

export type AvgTicketAgeBySeverityProps = Omit<
  AgeBySeverityTrendProps,
  "chartConfig"
>;

const AvgTicketAgeBySeverity: React.FC<AvgTicketAgeBySeverityProps> = (
  props
) => {
  return (
    <AgeBySeverityTrend
      {...props}
      chartConfig={ageBySeverityTrendConfigs.avgTicketAgeBySeverity}
    />
  );
};

export default AvgTicketAgeBySeverity;
